import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CartEffects } from 'src/app/feature/cart/redux/cart.effects';
import { cartReducer } from 'src/app/feature/cart/redux/cart.reducer';

@NgModule({
	declarations: [],
	exports: [],
	imports: [StoreModule.forFeature('cart', cartReducer), EffectsModule.forFeature([CartEffects])],
})
export class CartModule {}
